export default __webpack_public_path__ + "static/media/torso-low-back.5b58d1f7.png";